<template>
    <div>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="AirLead">
            <div class="AirLead__wrapper">
                <div class="AirLead__title">
                    {{ this.customerType == 'new' ? translate('airLeadNewCustomerLead') : translate('airLeadExistingCustomer') }}
                </div>
                <div class="AirLead__content">
                    <div class="AirLead__driver">
                        <div class="AirLead__driver-title">
                            {{translate('airLeadSubmittedBy')}}
                        </div>
                        <div class="AirLead__driver-dropdown">
                            <b-dropdown
                                :text="selectedDriver ? selectedDriver.first_name + ' ' + selectedDriver.last_name : translate('airLeadChooseDriver')"
                                ref="driver_dropdown"
                                toggle-class="driver-dropdown-toggle">
                                <b-dropdown-item v-for="item in airLeadDrivers" :key="item.id"
                                                 v-on:click="getDriverGuidAction(item)">
                                    <span> {{ item.first_name }} {{ item.last_name }}</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                    <div class="driver__info" v-if="customerType == 'new'">
                        <div class="input-wrapper">
                            <b-form-input type="text" placeholder=" " ref="company_input" class="form-control"
                                          v-model="driverInfo.newData.company"></b-form-input>
                            <label class="input-label">{{translate('airLeadCompanyName')}}</label>
                        </div>
                        <div class="input-wrapper">
                            <b-form-input type="text" placeholder=" " class="form-control"
                                          v-model="driverInfo.newData.phone"></b-form-input>
                            <label class="input-label">{{translate('bi_Phone')}}#</label>
                        </div>
                        <div class="input-wrapper" v-if="isProMode">
                            <label class="input-label dropdown" v-if="driverInfo.newData.siteType != ''">{{translate('airLeadSiteType')}}</label>
                            <b-dropdown
                                :text="driverInfo.newData.siteType != '' ? driverInfo.newData.siteType : translate('airLeadSiteType')"
                                toggle-class="driver-dropdown-toggle"
                            class="site-type-dropdown" :class="{selected: driverInfo.newData.siteType != ''}">
                                <b-dropdown-item v-for="item in siteTypes" :key="item.id"
                                                 v-on:click="onSiteTypeSelected(item)">
                                    <span> {{ item }}</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div class="input-wrapper">
                            <b-form-input type="text" placeholder=" " class="form-control"
                                          v-model="driverInfo.newData.opportunity"></b-form-input>
                            <label class="input-label">{{translate('airLeadOpportunity')}}?</label>
                        </div>
                    </div>
                    <div class="driver__info" v-else>
                        <div class="input-wrapper">
                            <b-form-input type="text" placeholder=" " ref="customer_id_input" class="form-control"
                                          v-model="driverInfo.existingData.customerId"></b-form-input>
                            <label class="input-label">{{translate('airLeadCustomer')}}</label>
                        </div>
                        <div class="service-wrapper" v-if="isProMode">
                            <div class="service-block">
                                <b-form-checkbox v-model="driverInfo.existingData.service.checked"></b-form-checkbox>
                                <span
                                    @click="driverInfo.existingData.service.checked = !driverInfo.existingData.service.checked">{{translate('airLeadMoreService')}}</span>
                            </div>
                            <b-form-input type="text" :placeholder="translate('airLeadMoreService')" ref="service_input"
                                          class="form-control simple" v-model="driverInfo.existingData.service.comment"
                                          v-show="driverInfo.existingData.service.checked"></b-form-input>
                        </div>
                        <div class="service-wrapper" v-if="isProMode">
                            <div class="service-block">
                                <b-form-checkbox v-model="driverInfo.existingData.units.checked"></b-form-checkbox>
                                <span
                                    @click="driverInfo.existingData.units.checked = !driverInfo.existingData.units.checked">{{translate('airLeadMoreUnits')}}</span>
                            </div>
                            <b-form-input type="text" :placeholder="translate('airLeadMoreUnits')" ref="units_input"
                                          class="form-control simple" v-model="driverInfo.existingData.units.comment"
                                          v-show="driverInfo.existingData.units.checked"></b-form-input>
                        </div>
                        <div class="service-wrapper" v-if="isProMode">
                            <div class="service-block">
                                <b-form-checkbox v-model="driverInfo.existingData.sink.checked"></b-form-checkbox>
                                <span
                                    @click="driverInfo.existingData.sink.checked = !driverInfo.existingData.sink.checked">{{translate('airLeadSink')}}</span>
                            </div>
                            <b-form-input type="text" :placeholder="translate('airLeadSink')" ref="sink_input" class="form-control simple"
                                          v-model="driverInfo.existingData.sink.comment"
                                          v-show="driverInfo.existingData.sink.checked"></b-form-input>
                        </div>
                        <div class="service-wrapper" v-if="isProMode">
                            <div class="service-block">
                                <b-form-checkbox v-model="driverInfo.existingData.call.checked"></b-form-checkbox>
                                <span
                                    @click="driverInfo.existingData.call.checked = !driverInfo.existingData.call.checked">{{translate('airLeadCallThem')}}</span>
                            </div>
                            <b-form-input type="text" :placeholder="translate('airLeadCallThem')" ref="call_input"
                                          class="form-control simple" v-model="driverInfo.existingData.call.comment"
                                          v-show="driverInfo.existingData.call.checked"></b-form-input>
                        </div>
                    </div>
                    <div class="driver__notes">
                        <div class="driver__notes-title">
                            {{translate('airLeadAdditionalNotes')}}
                        </div>
                        <textarea name="" id="" cols="30" rows="10" v-model="driverInfo.driverNote"></textarea>
                        <div class="note__buttons">
                            <div class="addContent__btn" @click="onAttachClick" v-if="true">
                                <img src="@/assets/icons/ic_photo.svg" alt="">
                            </div>
                            <div class="addContent__btn audio" @click="recordAudio()" v-if="!recordInProgress">
                                <img src="@/assets/icons/microphone_record.svg" alt="">
                            </div>
                            <div class="addContent__btn audio-stop" @click='stopRecordAudioClick()' :class="{active: recordInProgress}"></div>
                        </div>
                         <div class="audio_wrapper" id='audio'>
                            <div class="audio_delete" id="audio_delete" v-if="recordedAudio.length > 0" @click="deleteAudioClick">
                                <img src="@/assets/icons/ic_trash.svg" alt="">
                            </div>
                            <audio controls='controls' v-if="recordedAudio.length > 0">
                                <source :src="audioLink">
                            </audio>
                        </div>
                        <input
                            style="display: none"
                            type="file"
                            @change="onFileSelected"
                            ref="fileInput"
                            accept="image/png, image/jpeg"
                            multiple>
                        <div class="preview" v-if="files.length > 0">
                            <img v-for="(item, index) in files"
                                 :key="index"
                                 :src="item.url"
                                 @click="onFileClick(item)"/>
                        </div>
                    </div>
                    <div class="footer-btn">
                        <b-button class="save-btn" @click="addLeadClick">
                            {{translate('airLeadSubmitALead')}}
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="popupModal" :class="{active: selectedFile != null}">
                <div class="popupModal__wrapper"  @mousedown='underlayClick'>
                    <div class="popupModal__content" id="popupModal__content">
                        <div class="close-icon__wrapper">
                            <span class="close-icon" @click="selectedFile = null">
                                <img src="@/assets/icons/ic_close_white.svg">
                            </span>
                        </div>
                        <div class="photo-modal__wrapper">
                            <div class="photo-modal__image">
                                <img v-if="selectedFile" :src="selectedFile.url" />
                            </div>
                        </div>
                        <div class="photo-modal__buttons">
                            <div class="photo-modal__delete" @click="onDeleteImageClick">
                                {{translate('RemovePhoto')}}
                            </div>
                        </div>

                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import geoLocationMixin from "@/mixins/geoLocationMixin";
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapMutations, mapState} from 'vuex';
import customModalDialog from '@/components/widgets/customModalDialog';
import logAnalyticsEvent from '@/helpers/analytics'
import "@/assets/css/popapModal.css";

export default {
    mixins: [mixin, geoLocationMixin, errorMixin],
    components: {
        customModalDialog,
    },
    data() {
        return {
            customerType: 'new',
            isProMode: false,
            airLeadDrivers: [],
            userLocation: {
                lat: 0,
                lng: 0,
                accuracy: 0
            },
            selectedDriver: null,
            files: [],
            photoSize: 20, // megabytes
            maxFiles: 5,
            selectedFile: null,
            driverInfo: {
                existingData: {
                    customerId: '',
                    service: {
                        checked: false,
                        comment: ''
                    },
                    units: {
                        checked: false,
                        comment: ''
                    },
                    sink: {
                        checked: false,
                        comment: ''
                    },
                    call: {
                        checked: false,
                        comment: ''
                    }
                },
                newData: {
                    company: '',
                    phone: '',
                    siteType: '',
                    opportunity: ''
                },
                driverNote: ''
            },
            customModalSettings: {},
            recorder: null,
            deleteRecordAudioImage: null,
            recordedAudio: [],
            audioLink: null,
            recordInProgress: false,
            siteTypes: [
                'Construction',
                'Seasonal',
                'Long Term',
                'Special Event',
                'Disaster',
            ],
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        })
    },
    watch: {
        'driverInfo.existingData.service.checked'(value) {
            if (value) this.focusInputWithTimeout('service_input')
        },
        'driverInfo.existingData.units.checked'(value) {
            if (value) this.focusInputWithTimeout('units_input')
        },
        'driverInfo.existingData.sink.checked'(value) {
            if (value) this.focusInputWithTimeout('sink_input')
        },
        'driverInfo.existingData.call.checked'(value) {
            if (value) this.focusInputWithTimeout('call_input')
        },
    },
    async mounted() {
        this.initFetchLocationFlow()
        this.getDrivers()
        let hasLastDriver = this.fetchLastDriver()
        this.customerType = this.$route.params.type == 'new' ? 'new' : 'existing'
        if (!hasLastDriver) {
            this.$refs.driver_dropdown.show()
        } else if (this.customerType == 'new') {
            this.focusInputWithTimeout('company_input')
        } else {
            this.focusInputWithTimeout('customer_id_input')
        }
    },
    methods: {
        ...mapMutations({
            setProgressBarTag: 'setProgressBarTag',
        }),
        ...mapActions({
            getInitialData: 'airLead/getInitialData',
            addLeadAction: 'airLead/addLead'
        }),

        catchOpenSelect() {
            let select = document.getElementById('drivers')
            console.log(select)
        },

        async getDrivers() {
            console.log(this.driverInfo)
            try {
                const response = await this.getInitialData(this.$route.params.questionId)
                console.log(response)
                this.airLeadDrivers = response.data.drivers
                this.airLeadDrivers = this.airLeadDrivers.sort(function(q1, q2) {
                    return q1.first_name < q2.first_name ? -1 : q1.first_name > q2.first_name;
                });
                this.isProMode = response.data.pro_mode
            } catch (error) {
                console.log(error)
            }
        },
        async initFetchLocationFlow() {
            try {
                let position = await this.fetchUserLocation(30000)
                this.userLocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                }
            } catch (e) {
                console.log(`kek error:`, e)
                if (e.code == e.PERMISSION_DENIED) {
                    console.log(`kek error:`, e)
                }
            }
        },
        async addLeadClick() {
            if (!this.selectedDriver) {
                this.showErrorModal(this.translate('airLeadPleaseChooseDriver'), {duration: 1000})
                this.$refs.driver_dropdown.show()
                return
            }
            let data = {}
            if (this.customerType == 'new') {
                data = {
                    company_name: this.driverInfo.newData.company,
                    phone: this.driverInfo.newData.phone,
                    site_type: this.driverInfo.newData.siteType,
                    opportunity: this.driverInfo.newData.opportunity
                }
                if (data.company_name.trim() == '' && data.phone.trim() == '' && !this.hasRecordedAudio()) {
                    this.showErrorModal(this.translate('airLeadPleaseCompanyInfo'), {duration: 1000})
                    this.focusInputWithTimeout('company_input')
                    return
                }
            } else {
                data = {
                    customer_id: this.driverInfo.existingData.customerId,
                }
                let services = []
                if (this.driverInfo.existingData.sink.checked) services.push({
                    name: 'sink',
                    comment: this.driverInfo.existingData.sink.comment
                })
                if (this.driverInfo.existingData.call.checked) services.push({
                    name: 'call',
                    comment: this.driverInfo.existingData.call.comment
                })
                if (this.driverInfo.existingData.units.checked) services.push({
                    name: 'units',
                    comment: this.driverInfo.existingData.units.comment
                })
                if (this.driverInfo.existingData.service.checked) services.push({
                    name: 'more_service',
                    comment: this.driverInfo.existingData.service.comment
                })
                data.services = services

                if (data.customer_id.trim() == ''
                    && data.services.length == 0
                    && this.driverInfo.driverNote.trim() == ''
                    && !this.hasRecordedAudio()) {
                    this.showErrorModal(this.translate('airLeadPleaseCustomerInfo'), {duration: 1000})
                    if(data.customer_id.trim() == '') this.focusInputWithTimeout('customer_id_input')
                    return
                }
            }
            const body = {
                question_guid: this.$route.params.questionId,
                creator_guid: this.selectedDriver.guid,
                type: this.customerType,
                notes: this.driverInfo.driverNote,
                data: data,
                location: this.userLocation,
                images: this.files.map(item => item.file),
                audio: this.recordedAudio.length > 0 ? new Blob(this.recordedAudio, { type: this.recorder.mimeType,}) : null,
            }
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'add_airlead'
                })
                const response = await this.addLeadAction(body)
                this.$router.push({name: 'AirLeadSuccess'});
            } catch (error) {
                console.log(error)
                this.showErrorModal(error.data.error.message)
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'add_airlead'
                })
            }
        },
        getDriverGuidAction(item) {
            this.selectedDriver = item
            console.log(this.selectedDriver)
            let newDay = new Date().setHours(24, 59, 59, 59)
            this.selectedDriver.expiredDate = newDay
            console.log(this.selectedDriver)
            localStorage.setItem('airleadDriver', JSON.stringify(this.selectedDriver))

            if (this.customerType == 'new') {
                this.focusInputWithTimeout('company_input')
            } else {
                this.focusInputWithTimeout('customer_id_input')
            }
        },
        onSiteTypeSelected(item) {
            this.driverInfo.newData.siteType = item
        },
        fetchLastDriver() {
            let driver = JSON.parse(localStorage.getItem('airleadDriver'))
            if (driver) {
                let currentDate = new Date()
                if (driver.expiredDate < currentDate) {
                    localStorage.removeItem('airleadDriver')
                    return false
                } else {
                    this.selectedDriver = driver
                    return true
                }
            }
        },

        hasRecordedAudio() {
            return this.recordedAudio.length > 0
        },

        onFileSelected(event) {
            console.log(`onFileSelected files:`, event.target.files)
            for (let i = 0; event.target.files.length > i; i++) {
                let selectedFile = event.target.files[i];
                if (selectedFile.type != 'image/png' && selectedFile.type != 'image/jpeg') {
                    this.showErrorModal(this.translate('WrongFormat'))
                } else if ((selectedFile.size >= (this.photoSize * 1048576))) {
                    this.showErrorModal(this.translate('PhotoOverweight', [this.photoSize]))
                } else {
                    if (this.files.length == this.maxFiles) {
                        this.$refs.fileInput.value = ''
                        this.showErrorModal(this.translate('max_attach_photos_count_error', [this.maxFiles]))
                        return
                    }
                    this.files.push({
                        file: selectedFile,
                        url: URL.createObjectURL(selectedFile)
                    })
                }
            }
            this.$refs.fileInput.value = ''
        },
        onAttachClick() {
            if (this.files.length < this.maxFiles) this.$refs.fileInput.click()
        },
        onFileClick(item) {
            this.selectedFile = item
        },
        submitCheck() {
            console.log(this.driverInfo)
        },
        focusInputWithTimeout(ref) {
            setTimeout(() => {
                this.$refs[ref].focus()
            }, 200);
        },
        hideAll() {
        //todo
        },
        clearAll() {
            //todo remove photos
            //todo remove audio
            this.driverInfo = {
                existingData: {
                    customerId: '',
                    service: {
                        checked: false,
                        comment: ''
                    },
                    units: {
                        checked: false,
                        comment: ''
                    },
                    sink: {
                        checked: false,
                        comment: ''
                    },
                    call: {
                        checked: false,
                        comment: ''
                    }
                },
                newData: {
                    company: '',
                    phone: '',
                    siteType: '',
                    opportunity: ''
                },
                driverNote: ''
            }
        },
        onDeleteImageClick() {
            if(this.selectedFile == null) return
            this.files = this.files.filter(item => {
                return item.url != this.selectedFile.url
            })
            this.selectedFile = null
        },
        underlayClick(e) {
            if(this.isClickOutOfBlock('popupModal__content', e.target)){
                console.log(`underlayClick`)
                this.selectedFile = null
            }
        },
        recordAudio() {
            logAnalyticsEvent('al_audio_rec_clk')
            let device = navigator.mediaDevices.getUserMedia({audio: true});
            device.then((stream) => {
                this.recorder = new MediaRecorder(stream);
                this.recordInProgress = true
                this.recordAction()
                this.recorder.start();
                setTimeout(() => {
                    this.recorder.stop();
                    this.recordInProgress = false
                }, 60000);
            })
        },
        recordAction () {
            if(this.recordedAudio.length > 0) {
                this.recordedAudio.shift()
            }
            this.recorder.ondataavailable = (e) => {
                this.recordedAudio.push(e.data)
                let blob = new Blob(this.recordedAudio, { type: this.recorder.mimeType,});
                this.audioLink = URL.createObjectURL(blob)
            };
        },
        stopRecordAudioClick() {
            logAnalyticsEvent('al_audio_rec_stop_clk')
            this.recordInProgress = false
            this.recorder.stop();
        },
        deleteAudioClick() {
            logAnalyticsEvent('al_audio_rec_remove_clk')
            this.recordedAudio.shift()
        }
    }

}
</script>

<style>
.dropdown-menu {
    z-index: 9999999 !important;
}

.driver-dropdown-toggle {
    background: white !important;
    border: 1px solid black;
    color: black !important;
}
</style>
<style scoped>

.AirLead /deep/ .dropdown-menu {
    max-height: 400px;
    overflow-y: auto;
}
.AirLead {
    display: flex;
    justify-content: center;
}

li {
    display: flex;
}

.AirLead__wrapper {
    max-width: 500px;
    background: #FFFFFF;
    width: 500px;
}

.AirLead__title {
    text-align: center;
    margin-top: 27px;
}

.AirLead__content {
    padding-left: 24px;
    padding-right: 24px;
}

.AirLead__driver {
    margin-top: 23px;
}

input[type="checkbox"] {
    width: auto;
    margin-left: 0;
}

.driver__info {
    margin-top: 0px;
}

.driver__notes {
    margin-top: 24px;
}

.driver__notes textarea {
    max-height: 70px;
    width: 100%;
    margin-top: 12px;
}

.note__buttons {
    display: flex;
}

.addContent__btn {
    cursor: pointer;
    border: 1px solid black;
    border-radius: 6px;
    width: 85px;
    padding: 5px;
    display: flex;
    justify-content: center;
    margin-right: 15px;
}

.addContent__btn img {
    width: 15px;
    height: 15px;
}

.preview {
    padding-top: 4px;
}

.preview img {
    max-width: 100%;
    max-height: 50px;
    padding-right: 5px;
    padding-bottom: 10px;
}

.service-block {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.service-block span {
    margin-left: 4px;
    margin-top: 4px;
    width: 100%;
    cursor: pointer;
}

.service-wrapper {
    margin-top: 12px;
}

.AirLead__driver-dropdown {
    margin-top: 8px;
}

.input-wrapper {
    width: 100%;
    margin-top: 24px;
}
.site-type-dropdown {
    margin-top: 12px;
}
.input-label.dropdown {
    top: -14px !important;
    transition: all .3s ease;
    font-size: 14px;
}
.input-label {
    position: absolute;
    z-index: 999;
    top: 10px;
    pointer-events: none;
    transition: all .3s ease;
}

input:not(:placeholder-shown) ~ .input-label,
input:focus ~ .input-label {
    top: -15px;
    transition: all .3s ease;
    font-size: 14px;
}

.form-control {
    position: relative;
    border: none;
    border-bottom: 1px solid #2F2F2F;
    outline: none;
    border-radius: 0;
    padding-left: 0;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    color: black;
}

.form-control:focus {
    outline: none !important;
    text-decoration: none;
    box-shadow: none;
    border-color: #2F2F2F;
    color: black;
}

input::-webkit-calendar-picker-indicator {
    display: none;
}

.form-control::placeholder {
    font-size: 14px;
    color: #2F2F2F;
}

.form-control.simple::placeholder {
    font-size: 16px;
    color: #cdcdcd;
}

.form-control.simple {
    margin-top: 4px;
}

.footer-btn {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    margin-bottom: 32px;
}

.save-btn {
    background: #3F405C;
    border-radius: 6px;
    color: #ffffff;
    border: 0;
    padding: 12px 62px;
    cursor: pointer;
}
.close-icon__wrapper {
    display: flex;
    justify-content: flex-end;
}
.close-icon {
    position: static;
    cursor: pointer;
    width: 28px;
    height: 28px;
    /*background: url(../assets/icons/ic_close_white.svg) 50% no-repeat;*/
}
.photo-modal__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
}
.photo-modal__image img {
    max-width: 100%;
    max-height: 250px;
}
.photo-modal__buttons {
    display: flex;
    justify-content: center;
    margin-top: 35px;
}.photo-modal__change {
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-right: 25px;
}
.photo-modal__delete {
    width: 100%;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    color: #FFFFFF;
    background-color: #3F405C;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.addContent__btn.audio-stop {
    width: 20px;
    height: 20px;
    font-size: 0;
    background-color: red;
    border: 0;
    border-radius: 35px;
    outline: none;
    cursor: pointer;
    display: none;
}
.addContent__btn.audio-stop.active {
    display: block;
    animation-name: pulse;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}
.audio_wrapper {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
}
audio {
    width: 90%;
    height: 50px;
}
.audio_delete {
    margin-left: 10px;
    cursor: pointer;
    margin-top: 5px;
}
 @keyframes pulse{
    0%{
        box-shadow: 0px 0px 5px 0px rgba(173,0,0,.3);
    }
    65%{
        box-shadow: 0px 0px 5px 10px rgba(173,0,0,.3);
    }
    90%{
        box-shadow: 0px 0px 5px 10px rgba(173,0,0,0);
    }
}
</style>
